import React, { useState, ReactChild } from 'react'
import LiveModal from 'live/components/ui/Modal'
import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import i18n from 'live/services/i18n'
import theme from 'live/services/theme'

type PropsModal = {
    showModal: boolean,
    setShowModal: Function,
    children: ReactChild,
    disable: boolean,
    setSubmit: Function
}

function ModalWidgetCSB(props: PropsModal) {
    const { showModal, setShowModal, children, disable, setSubmit } = props

    return (
        <Container>
            <Main>
                <div className="importExport">
                    <StyledLiveModal show={showModal} onHide={() => setShowModal(false)}>
                        <Modal.Header>
                            <Modal.Title>
                                <span className="capitalize">{i18n('Import schematic from CSB')}</span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>{children}</Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                id="btnOk"
                                className="btn btn-primary btn-lg btn-bold"
                                onClick={() => setSubmit(true)}
                                disabled={disable}
                            >
                                {i18n('Import')}
                            </button>
                            <span>
                                <span className="submit-or-cancel">{i18n('Or')} </span>
                                <a onClick={() => setShowModal(false)}>{i18n('Cancel')}</a>
                            </span>
                        </Modal.Footer>
                    </StyledLiveModal>
                </div>
            </Main>
        </Container>
    )
}

export default ModalWidgetCSB

const Container = styled.div``

const Main = styled.div`
    .titleImport {
        height: 14px;
        font-family: ${({ theme }) => theme['font-semibold']};
        font-size: 11px;
        font-weight: 600;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #606a80;
        margin-right: 8px;
    }
    .fileImportExport {
        cursor: pointer;
    }
    .notAllowed,
    .notAllowed .fa {
        cursor: not-allowed;
    }
    .fa {
        width: 12px;
        height: 16px;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #37a3ef;
        cursor: pointer;
    }
`

const StyledLiveModal = styled(LiveModal)`
    .modal-dialog {
        width: 600px;
    }
    z-index: 1040;
    .capitalize {
        text-transform: capitalize;
    }
    .modal-header {
        position: relative;
        padding: 0;
    }
    .modal-body {
        background: #eeeeee;
        padding: 0;
        overflow: auto;
        position: relative;
        max-height: 400px;
    }
    .btn {
        border-radius: 0;
    }
    .modal-footer {
        border-top: none;
    }
    .modal-title {
        width: 100%;
        padding-left: 23px;
        color: #364159;
        font-style: normal;
        font-weight: normal;
        font-family: ${({ theme }) => theme['font-semibold']};
        font-size: 18px;
    }
`
